import { Directive, Input, HostBinding } from '@angular/core';

@Directive({
  selector: '[defaultCover]',
  host: {
    '(error)': 'updateUrl()',
    '(load)': 'load()',
    '[src]': 'src'
  }
})
export class DefaultCoverDirective {
  @Input()
  watchLoad: boolean;

  @Input()
  src: string;

  @Input()
  defaultCover: string;

  @HostBinding('class.loaded')
  isLoaded = false;

  updateUrl() {
    this.src = this.defaultCover;
  }

  load() {
    if (this.watchLoad) {
      this.isLoaded = true;
    }
  }
}
